export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/pointRadial.js
// module id = 167
// module chunks = 0 1 2 3 4